import { firstValueFrom } from 'rxjs';
import {
  DischargeInfo,
  DischargeInfoDto,
  RequestDto,
} from '../models/request.dto';
import { AuthService } from '../services/auth.service';
import { RequestService } from '../services/request.service';
import { FormDto } from '../models/form.dto';
import { AttachmentService } from '../services/attachment.service';

export async function handleOspedaleDiComunitaPreSave(
  api: any,
  request: RequestDto,
  requestDates: DischargeInfo[],
      services: { requestService: RequestService; authService: AuthService; attachmentService: AttachmentService },
      form: FormDto,
      compositionId: string,
) {
  const dischargeDate = api?.getFieldValue(
    'proposta_per_l_ammissione_in_ospedale_di_comunita/proposta_per_ammissione_ospedale_comunita/data_di_presunta_dimissione'
  );

  if (dischargeDate) {
    let payload: DischargeInfoDto = {
      date: dischargeDate+'T00:00:00',
      operatorCode: services.authService.userInfo.username,
      transitionId: request.id,
      typeId: 1,
    };
    if (requestDates && requestDates.find((d) => d.dateType?.code == 'DDP')) {
      payload.id = requestDates.find((d) => d.dateType?.code == 'DDP')?.id;
      await firstValueFrom(
        services.requestService.updateDischargeInfo(payload)
      );
    } else {
      await firstValueFrom(
        services.requestService.createDischargeInfo(payload)
      );
    }
  }  

  const attachmentCode = api?.getFieldModel(
    'proposta_per_l_ammissione_in_ospedale_di_comunita/context/paziente/l104_string'
  )?.value[0]?.label;

  const fileName = api?.getFieldModel(
    'proposta_per_l_ammissione_in_ospedale_di_comunita/context/paziente/nome_allegato'
  )?.value[0];

  const fileContentType = api?.getFieldModel(
    'proposta_per_l_ammissione_in_ospedale_di_comunita/context/paziente/estensione_allegato'
  )?.value[0];

  const fileuuid = api?.getFieldModel(
    'proposta_per_l_ammissione_in_ospedale_di_comunita/context/paziente/uuid'
  )?.value[0];


  let requestAttachment = {
    transitionUuid: request.uuid,
    attachmentCode: attachmentCode,
    formId: form.id,
    compositionId: form.compositionId ? form.compositionId : compositionId,
    fileName: fileName,
    fileContentType: fileContentType,
    fileUuid: fileuuid
  }

  await firstValueFrom(
        services.attachmentService.insertAttachmentFromForm(requestAttachment)
      );
}
